import React from "react";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { MediaFilesController } from "lib/MediaFileController";
import "./style.scss";

interface Props {
  className?: string;
  src?: string;
  user?: User | UserPublicData | null;
  size: number;
}

function BaseAvatar({ className = "", user, size }: Props) {
  const src =
    (user?.avatar && MediaFilesController.getImageThumbnail(user.avatar.urlPart, "240p")) ||
    "/images/default-avatar.svg";
  const cls = ["base-avatar"];

  cls.push(className);

  return (
    <div className={cls.join(" ")} style={{ width: size, height: size }}>
      <img src={src} alt="avatar" className="base-avatar__avatar" />
    </div>
  );
}

export default BaseAvatar;
